export default {
  delete_success: 'The offer has been deleted successfully',
  delete_failed: 'The offer deletion failed',
  delete_confirm_title: 'Are you sure you want to delete this offer?',
  delete_last_day_confirm_title: 'Removing the last remaining day will delete this offer. Are you sure?',
  confirm: 'Confirm',
  cancel: 'Cancel',
  qualifying_items: 'Qualifying items',
  free_items: 'Free items',
  all_day: 'All day',
  starts_on: 'Starts on {{date}}',
  ends_on: 'Ends on {{date}}',
  ends_when_deleted: 'Ends when deleted',
  off: '{{amount}} off',
  min_spend_value: 'Min spend: {{amount}}',
};
